"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/EmptyInbox.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _inbox = require('shared/hooks/inbox');

var _icons = require('./icons');












const ACTIVE_COPY = {
  [_inbox.InboxTab.ALL]: ({ inboxName, teamName }) => ({
    title: `No chats in ${inboxName}`,
    text: teamName ? `Chats that include the ${teamName} team show up here.` : "Chats you're in show up here.",
  }),
  [_inbox.InboxTab.UNREAD]: ({ inboxName }) => ({
    title: "You're all caught up",
    text: `No unread chats in ${inboxName}.`,
  }),
  [_inbox.InboxTab.REQUESTS]: () => ({
    title: 'No open requests',
    text: 'When a patient sends a keyword that flags the chat, it shows here until someone marks it handled.',
  }),
  [_inbox.InboxTab.PATIENTS]: ({ inboxName, teamName }) => ({
    title: `No patient chats in ${inboxName}`,
    text: teamName
      ? `Patient chats that include the ${teamName} team show up here.`
      : 'Your patient chats show up here.',
  }),
  [_inbox.InboxTab.TEAM]: ({ inboxName, teamName }) => ({
    title: `No staff chats in ${inboxName}`,
    text: teamName
      ? `Staff-only chats that include the ${teamName} team show up here.`
      : "Staff-only chats you're in show up here.",
  }),
  [_inbox.InboxTab.SCHEDULED]: ({ inboxName }) => ({
    title: `No scheduled messages in ${inboxName}`,
    text: 'Chats with a message waiting to send show up here.',
  }),
}

const ARCHIVED_NOUN = {
  [_inbox.InboxTab.ALL]: 'archived chats',
  [_inbox.InboxTab.UNREAD]: 'unread archived chats',
  [_inbox.InboxTab.REQUESTS]: 'archived chats with open requests',
  [_inbox.InboxTab.PATIENTS]: 'archived patient chats',
  [_inbox.InboxTab.TEAM]: 'archived staff chats',
  [_inbox.InboxTab.SCHEDULED]: 'archived chats with scheduled messages',
}

const ICONS = {
  [_inbox.InboxTab.ALL]: _icons.InboxIcon,
  [_inbox.InboxTab.UNREAD]: _icons.CheckIcon,
  [_inbox.InboxTab.REQUESTS]: _icons.CheckIcon,
  [_inbox.InboxTab.PATIENTS]: _icons.HeartIcon,
  [_inbox.InboxTab.TEAM]: _icons.TeamIcon,
  [_inbox.InboxTab.SCHEDULED]: _icons.ClockIcon,
}










/* What an empty tab says, and the way out of it: back to All, into Archived,
 * or (on Patients) a new text. */
const EmptyInbox = ({
  tab, isArchived, inboxName, teamName, onShowAll, onShowArchived, onTextPatient,
}) => {
  const { title, text } = isArchived
    ? { title: `No ${ARCHIVED_NOUN[tab]} in ${inboxName}` }
    : ACTIVE_COPY[tab]({ inboxName, teamName })
  const Icon = ICONS[tab]
  // As Round 3 draws them: Unread offers All; Requests offers nothing;
  // Patients offers Archived and a new text; inside Archived, a tab offers All.
  const showAll = tab === _inbox.InboxTab.UNREAD || (isArchived && tab !== _inbox.InboxTab.ALL)
  const showArchived = !isArchived && tab !== _inbox.InboxTab.UNREAD && tab !== _inbox.InboxTab.REQUESTS
  const textPatient = !isArchived && tab === _inbox.InboxTab.PATIENTS ? onTextPatient : undefined

  return (
    _react2.default.createElement('div', { className: "inbox-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      , _react2.default.createElement('div', { className: "inbox-empty--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, _react2.default.createElement(Icon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}} ))
      , _react2.default.createElement('div', { className: "inbox-empty--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}},  title )
      ,  text && _react2.default.createElement('p', { className: "inbox-empty--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}},  text ) 
      ,  (showAll || showArchived || textPatient) && (
        _react2.default.createElement('div', { className: "inbox-empty--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
          ,  showAll && (
            _react2.default.createElement('button', { type: "button", className: "inbox-empty--btn", onClick: onShowAll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}, "Show all chats"  )
          )
          ,  showArchived && (
            _react2.default.createElement('button', { type: "button", className: "inbox-empty--btn", onClick: onShowArchived, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, "Show archived" )
          )
          ,  textPatient && (
            _react2.default.createElement('button', { type: "button", className: "inbox-empty--btn inbox-empty--btn---primary" , onClick: textPatient, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}, "Text a patient"

            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, EmptyInbox)
